<template>
  <div class="step-slide-info">
    <div class="lighter">{{ $t('currentSlideId') }}</div>
    <copy-to-clipboard-text
        class="w-100"
        :value="slide.id" />
    <div class="lighter">{{ $t('currentSlideIndex') }}</div> {{ slideIndex }}<br>
    <div class="lighter">{{ $t('currentStepId') }}</div>
    <copy-to-clipboard-text :value="step" />
  </div>
</template>

<script>
import CopyToClipboardText from "@/components/CopyToClipboardText.vue";
export default {
  name: "SlideStepInfo",
  components: {
    CopyToClipboardText
  },
  props: {
   slide: {
      type: Object,
      required: true
    },
    slideIndex: {
      type: Number,
      required: true
    },
    step: {
      type: String,
      required: true
    },
  }
}
</script>

<style scoped lang="scss">
.step-slide-info {
  font-size: 0.9em;
  color: #fff;
  padding: 10px;
  background-color: var(--vform-editor-ui-secondary-color);
  border-radius: 5px;
  margin: 10px 0 10px 15px;
  max-width: 400px;
}
</style>